/* Copyright 2013 - 2024 Waiterio LLC */
import Restaurant from '@waiterio/model/Restaurant.js'
import get from '@waiterio/api-client/get.js'

export default function getRestaurant(parameters) {
  let url = 'restaurants'

  url += `?${new URLSearchParams(parameters).toString()}`

  return get({ url }).then(restaurants =>
    restaurants.map(restaurant => new Restaurant(restaurant)),
  )
}
